import * as React from 'react';
import { MultiItemStepIndicator } from '@shared-ui/multi-item-step-indicator';
import { UitkSpacing } from 'uitk-react-spacing';
import { SpacingSpace, SpacingSpaces, SpacingSpacesBreaks } from 'uitk-react-spacing/dist/types';
import { useStores } from 'utility/hooks';

export interface StepIndicatorProps {
  showLoadingStateOnSmallView?: boolean;
  showLoadingStateOnLargeView: boolean;
  padding?: SpacingSpace | SpacingSpaces | SpacingSpacesBreaks;
}

/**
 * @param showLoadingStateOnSmallView: For FSR and FIS, `showLoadingStateOnSmallView` is `true` to show skeleton lines
 * @param showLoadingStateOnLargeView: For FSR, `showLoadingStateOnSmallView` is `false` to hide skeleton lines and for FIS, `showLoadingStateOnSmallView` is `true` to show skeleton lines
 * @param classes: custom classes to be set into step indicator
 */
export const StepIndicator = ({
  showLoadingStateOnSmallView = true,
  showLoadingStateOnLargeView,
  padding
}: StepIndicatorProps) => {
  const { stepIndicatorStore, analytics, context } = useStores();
  const { journeyContinuationId, errorAnalytics } = stepIndicatorStore;
  const { linkName, rfrr } = errorAnalytics || {};

  const analyticsCallback = (rfrr: string, linkName: string | null): void => {
    analytics.trackEvent(rfrr, linkName || 'RFRR Action Event', analytics.omnitureData, null, true);
  };

  const errorCallback = (): void => {
    analytics.trackEvent(rfrr, linkName || 'RFRR Action Event', analytics.omnitureData, null, true);
  };

  const isLoadingStateOnSmallViewEnabled = () => context.deviceInformation.mobile || context.deviceInformation.tablet;
  const showLoadingState = isLoadingStateOnSmallViewEnabled()
    ? showLoadingStateOnSmallView
    : showLoadingStateOnLargeView;

  return (
    <section data-test-id="step-indicator-parent">
      <UitkSpacing padding={padding}>
        <MultiItemStepIndicator
          inputs={{ journeyContinuationId }}
          showLoadingState={showLoadingState}
          analyticsCallback={analyticsCallback}
          errorCallback={errorCallback}
        />
      </UitkSpacing>
    </section>
  );
};
